import React from 'react';
import './styles/infocard.css';

export interface InfoCardProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  variant?: 'default' | 'info' | 'success' | 'warning';
}

export const InfoCard: React.FC<InfoCardProps> = ({
  title,
  description,
  icon,
  variant = 'default',
}) => {
  return (
    <div className={`info-card info-card--${variant}`}>
      {icon && <div className="info-card__icon">{icon}</div>}
      
      <div className="info-card__content">
        <h4 className="info-card__title">{title}</h4>
        {description && <p className="info-card__description">{description}</p>}
      </div>
    </div>
  );
};